(function() {
  'use strict';

  /**
   * @ngdoc directive
   * @name webAgro1App.directive:widgettalhoesdiassemvisita
   * @description
   * # widgettalhoesdiassemvisita
   */
  angular
    .module('webAgro1App')
    .directive('widgetTalhoesDiasSemVisita', WidgetTalhoesDiasSemVisita);

  /**
   * Declare Widget Talhoes Dias Sem Visita
   * @return {Object}
   */
  function WidgetTalhoesDiasSemVisita() {

    //////////////////////////////////////////
    // Directive definition object
    var directive = {
      templateUrl: 'views/widgets/visitas/view.html',
      restrict: 'A',
      controller: 'WidgetTalhoesDiasSemVisitaCtrl',
      controllerAs: 'wctrl',
      scope: {
        widget: '=data'
      }
    };
    return directive;

  }

}());
